import React, { useEffect, useMemo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useParams } from 'react-router';
import history from 'routers/history';
import { useLogout } from 'pages/Header/Content/hooks/useLogin';
import { PROJECT_BASENAME } from 'constants/env'

const AgentLogin = () => {
  const { agentId } = useParams();
  const { logOut } = useLogout();

  useEffect(() => {
    logOut(false);
  }, []);

  const path = useMemo(() => `crear-mesa/${agentId}/admin-page`, [agentId]);

  

  const onLogin = () => {
    logOut(false);
    history.push(`/${path}`);
  };

  const onRegistration = () => {
    logOut(false);
    const { origin } = window.location;
    window.location.href = `${origin}/registro?redirect=${origin}${PROJECT_BASENAME}${path}`;
  };

  return (
    <Modal show onHide={() => {}}>
      <Modal.Body>¿El anfitrión tiene cuenta en sears.com.mx?</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onLogin}>
          Si
        </Button>
        <Button variant="primary" onClick={onRegistration}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AgentLogin;
